






















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ListSelect extends Vue {
  @Prop({ type: Object, required: true }) items!: { [key: string]: string }
  @Prop({ type: Array, required: true }) value!: string[]
  @Prop({ type: String, default: '4'}) columns!: string

  selection: string[] = [...this.value]

  get list(): { key: string, value: string }[] {
    return Object.keys(this.items)
      .map(key => ({
        key: key,
        value: this.items[key]
      }))
  }

  manageSelection(val) {
    if (this.selection.includes(val)) {
      this.selection.splice(this.selection.indexOf(val), 1)
    } else {
      this.selection.push(val)
    }
    this.$emit('input', this.selection)
  }
}
